import { BrowserHistory } from 'history';

export const historyRef: { current: BrowserHistory } = { current: null as any };

export const history = {
	push: (to: string, state?: object | null) => historyRef.current.push(to, state),
};
